var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", [
      _c(
        "a",
        { staticClass: "btn btn-primary mx-auto", on: { click: _vm.reload } },
        [_vm._v(_vm._s(_vm.$t("btn_label_close")))]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-success" }, [
      _c("h3", [_vm._v("Dziękujemy bardzo za wiadomość.")]),
      _vm._v(" "),
      _c("p", [_vm._v("\n      Zgłoszenie zostało zarejestrowane.\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Dodatkowo informujemy, że informację dotyczącą zgłoszenia przesłaliśmy na adres e-mail wskazany przez Pana/Panią w formularzu."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }